import React from 'react'
import Main from '../elements/MainElements/Main'
import {
    BrowserRouter as Router,
    Switch,
    Route,
  } from "react-router-dom";
import SinglePokemon from '../elements/SinglePokemon';


const Pages = () => {
    return (
        <Router>
      <Switch>
        <Route exact path="/">
          <Main />
        </Route>
        <Route path="/pokemon/:id">
        <SinglePokemon />
        </Route>
      </Switch>
    </Router>
    )
}

export default Pages


